import { Table, TableBody, TableContainer } from "@mui/material";
import { Order } from "layout/ListLayout/types";
import { useMemo, useState } from "react";
import { getComparator } from "helpers/sort";
import dayjs from "dayjs";
import { toggleItemInArray } from "helpers/index";
import Head from "./Head";
import { CompanyCandidates, Data, DataWithIstelegramFlag } from "../types";
import Row from "./Row";

interface CandidatesTableProps {
  data: CompanyCandidates;
  selected: string[];
  setSelected: (values: string[]) => void;
}

const CandidatesTable = ({ data, selected, setSelected }: CandidatesTableProps) => {
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof Data>("id");

  const rows: DataWithIstelegramFlag[] = data
    ? data.map((item) => ({
        id: item.id,
        numericId: item.numericId,
        fullName: item.fullName,
        isTelegramUser: !!item.candidateUsername?.telegramUsername,
        nickname: item.candidateUsername?.telegramUsername || item.candidateUsername?.login || "",
        createdAt: dayjs(item.createdAt).format("DD.MM.YYYY"),
      }))
    : [];

  const handleRequestSort = (property: keyof Data) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (id: string) => {
    const newSelected = toggleItemInArray(selected, id);

    setSelected(newSelected);
  };

  const sortedRows = useMemo(() => [...rows].sort(getComparator(order, orderBy)), [order, orderBy, data]);

  return (
    <TableContainer sx={{ marginTop: 2, maxHeight: 215, paddingRight: 1.5 }}>
      <Table size='small'>
        <Head
          order={order}
          orderBy={orderBy}
          onRequestSort={handleRequestSort}
        />
        <TableBody>
          {sortedRows.map((row, index) => (
            <Row
              key={`enhanced-table-row-${row.numericId}`}
              row={row}
              isItemSelected={selected.includes(row.id)}
              labelId={`enhanced-table-checkbox-${index}`}
              handleClick={handleClick}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CandidatesTable;
